<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-batch-activation`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42.264 30.707l1.414 1.414a1 1 0 010 1.414l-9.9 9.9a1 1 0 01-1.414 0l-5.657-5.657a1 1 0 010-1.414l1.414-1.414a1 1 0 011.415 0l3.535 3.535 7.778-7.778a1 1 0 011.415 0zM41 4a2 2 0 012 2v20h-4V8H9v31h14v4H7a2 2 0 01-2-2V6a2 2 0 012-2h34zM19.549 24c2.334 0 4.163 1.237 5.486 3.712 1.133-1.903 2.635-2.855 4.506-2.855 2.376 0 4.133 1.535 5.27 4.604a.4.4 0 01-.374.539H13.573a.4.4 0 01-.373-.544C14.603 25.82 16.72 24 19.549 24zm9.951-6c1.636 0 2.962 1.535 2.962 3.429 0 1.893-1.326 3.428-2.962 3.428-1.636 0-2.962-1.535-2.962-3.428 0-1.894 1.326-3.429 2.962-3.429zm-10-2c1.933 0 3.5 1.79 3.5 4s-1.567 4-3.5 4-3.5-1.79-3.5-4 1.567-4 3.5-4z"/></svg>
</template>
<script>

export default {
  name: 'IconBatchActivation',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
